import AOS from "aos";
import React, { useEffect } from "react";
import "aos/dist/aos.css";
import TypeWriterEffect from "react-typewriter-effect";

export default function Loader() {
  const sec = 3000;
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, [sec]);
  const myAppRef = document.querySelector(".type_div");
  return (
    <div className="bg-[#191919] h-screen text-white text-8xl flex justify-center flex-col text-center">
      <div className="type_div grid place-items-center">
        <TypeWriterEffect
          textStyle={{
            fontWeight: 700,
            fontSize: "12vw",
          }}
          startDelay={50}
          cursorColor="black"
          hideCursorAfterText={true}
          text="Dev-Guy"
          typeSpeed={300}
          scrollArea={myAppRef}
        />
      </div>
      <div className="balls flex justify-between mt-20 w-40 mx-auto">
        <div className="ball ball1 bg-red-600"></div>
        <div className="ball ball3 bg-yellow-400"></div>
        <div className="ball ball2 bg-green-600"></div>
      </div>
    </div>
  );
}
